module.exports = __webpack_public_path__ + "images/github.png?d56df49a807a9fd06eb1667a84d3810e";


//////////////////
// WEBPACK FOOTER
// ./src/images/github.png
// module id = 760
// module chunks = 0